<!-- 品牌服务详情 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="info-detail-title-1">
      <div class="title-info">
        <div class="title">{{detail.name}}</div>
        <table class="title-detail-table" cellpadding="2" cellspacing="0">
          <tr>
            <th>服务价格：</th>
            <th>服务类别：</th>
            <th>服务方式：</th>
            <th>服务热线：</th>
          </tr>
          <tr>
            <td class="td-value">{{detail.place}}</td>
            <td class="td-value">{{detail.type}}</td>
            <td class="td-value">{{detail.pattern}}</td>
            <td class="td-value">{{detail.tel}}</td>
          </tr>
        </table>
      </div>
      <div class="title-act" >
        <div class="logo" v-bind:style="{backgroundImage:'url('+detail.logo+')'}"></div>
        <div class="enterprise">{{detail.enterprise_name}}</div>
        <div class="business">{{detail.primary_business}}</div>
        <a href="#" class="td-action-1">在线咨询</a>
      </div>
    </div>
    <div class="content-row">
      <div class="content-col col-per-70">
        <div class="info-list-title">
          <span>服务内容</span>
          <label>SERVICE CONTENT</label>
        </div>
        <div class="info-detail-content"  v-html="detail.desc">
        </div>
      </div>
      <div class="content-col col-per-30">
        <div class="info-list-title">
          <span>服务申请</span>
          <label>DEMAND SERVICE</label>
        </div>
        <div class="info-detail-content">
          <ul class="info-detail-zh-other">
            <li class="label">
              <input type="text" name="userName" class="service-input" v-model="userName" placeholder="联系人"/>
            </li>
            <li class="label">
              <input type="text" name="userPhone" class="service-input" v-model="userPhone" placeholder="联系电话"/>
            </li>
            <li class="label">
              <input type="text" name="enterpriseName" class="service-input" v-model="enterpriseName" placeholder="企业名称"/>
            </li>
            <li class="label remark">
              <textarea name="remark" class="service-area" v-model="remark" placeholder="需求描述"></textarea>
            </li>
            <li class="label"><a href="#" class="td-action-2">申请服务</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList01 from '../block/InfoPageList01'
import InfoList04 from '../block/InfoList04'
import InfoDetail01 from '../block/InfoDetail01'
export default {
  name: 'Detail02',
  components: {
    'infoDetail-01': InfoDetail01,
    'infoList-04': InfoList04,
  },
  data() {
    return {
      msg: '',
      userName:'',
      userPhone:'',
      enterpriseName:'',
      remark:'',
      detail:{},
    }
  },
  methods:{
    detail_Req(detailId){
      let that=this;
      let params={id:detailId};
      that.$dataApi.orgServiceDetail(params).then(res =>{
          that.msg=res.msg;
          that.detail=res.data;
          //console.log('结束请求Vue-axios：'+JSON.stringify(that.detailInfo))
        });
    },
  },
  created:function(){
    let that=this;
    let detailId=that.$route.params.id;
    //this.newsDetail=this.Global.newsDetail;
    //console.log("当前导航页："+this.Global.siteDefaultNav);

    that.detail_Req(detailId);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}

.site-detail-page{

}

.info-detail-title-1{
  position:relative;
  width:100%;
  height:355px;
  //background:#eee;
  padding:0px 0px 0px 0px;
  margin-top:0px;
  margin-bottom:0px;
  border-bottom:0px;
  text-align:left;
  background-image:url(./../../assets/service_bg.jpg);
  background-size: auto 355px;
  background-repeat: no-repeat;
  background-position: 0px 0px;
}
.info-detail-title-1 .title-img{
  float:left;
  width: 240px;
  height:140px;
  text-align:left;
  background:#ddd;
}

.info-detail-title-1 .title-img img{
  float:left;
  width: 240px;
  height:140px;
}

.info-detail-title-1 .title-info{
  float:left;
  width: calc(100% - 430px);
  text-align:left;
  padding-left:20px;
}

.info-detail-title-1 .title-act{
  float:left;
  height:280px;
  width:430px;
  margin-top:30px;
  padding-left:40px;
  padding-top:40px;
  text-align:left;
  border-left:1px solid #515151;
}

.info-detail-title-1 .logo{
  position:absolute;
  height:40px;
  width:40px;
  color:#fff;
  background-size:40px 40px;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius:5px;
}

.info-detail-title-1 .enterprise{
  position:relative;
  height:50px;
  line-heigth:50px;
  padding-left:50px;
  font-size:16px;
  font-weight:600;
  line-height:40px;
  color:#fff;
}

.info-detail-title-1 .business{
  position:relative;
  //background:yellow;
  height:120px;
  line-height:25px;
  padding-left:50px;
  padding-right:30px;
  font-size:14px;
  font-weight:100;
  color:#888;
}

.info-detail-title-1 .title{
  padding:5px 5px 5px 20px;
  margin:20px;
  margin-bottom:40px;
  border-bottom:0.08rem solid #515151;
  height:120px;
  font-size:18px;
  font-weight:800;
  line-height:100px;
  text-align:left;
  color:#fff;
}

.title-detail-table{
  padding-left:20px;
  font-size:12px;
  line-height:20px;
  width:100%;
}

.title-detail-table th{
  padding-left:40px;
  font-size:14px;
  font-weight:100;
  line-height:30px;
  border-left:1px solid #515151;
  color:#fff;
}

.title-detail-table th:first-child{
  border-left:0px solid #ddd;
}

.title-detail-table .td-value{
  padding-left:40px;
  font-size:14px;
  font-weight:600;
  line-height:30px;
  border-left:1px solid #515151;
  color:var(--color7);
}

.title-detail-table td:first-child{
  border-left:0px solid #ddd;
}

.info-detail-zh-other{
  display:block;
  list-style-type: none;
  padding: 10px;
  margin-top:20px;
  font-size:12px;
  background:#eee;
}

.info-detail-zh-other .label {
  display:block;
  margin: 0px 0px 10px 0px;
  padding:0px;
  width:100%;
  height:50px;
  text-align:left;
  color:#888;
}

.info-detail-zh-other .remark {
  position:relative;
  margin: 0px 0px 2px 0px;
  padding:0px;
  height:120px;
  text-align:left;
  color:#000;
}

.info-detail-zh-other input{
  height:40px;
  width:100%;
  padding-left:10px;
  padding-right:10px;
  text-align:left;
  font-size:14px;
  border:1px solid #ddd;
  border-radius:5px;
  background:#fff;
}

.info-detail-zh-other input:focus{
   outline:none;
   border:1px solid var(--color6);
   background: #fff;
   color:#000;
}

.info-detail-zh-other textarea{
  height:100px;
  width:100%;
  padding:10px;
  font-size:14px;
  text-align:left;
  border:1px solid #ddd;
  border-radius:5px;
  background:#fff;
}

.info-detail-zh-other textarea:focus{
   outline:none;
   border:1px solid var(--color6);
   background: #fff;
   color:#000;
}


.td-action-1{
  display:block;
  height:30px;
  width:100px;
  padding:5px 15px 5px 15px;
  margin-top:30px;
  margin-left:50px;
  border:1px solid var(--color7);
  color:var(--color7);
  background:#fff;
  line-height:20px;
  text-align:center;
}

.td-action-1:hover{
  color:#fff;
  background:var(--color7);
  border:1px solid var(--color7);
}

.td-action-2{
  display:block;
  height:30px;
  width:100px;
  padding:5px 15px 5px 15px;
  margin:0px auto;
  border:1px solid var(--color7);
  color:#fff;
  background:var(--color7);
  text-align:center;
}

.td-action-2:hover{
  color:#fff;
  background:var(--color7);
  border:1px solid var(--color7);
}

.info-detail-content img{max-width:1200px}
</style>



// WEBPACK FOOTER //
// src/components/page/Cyfw02Detail.vue